module.exports = __webpack_public_path__ + "img/10.bcf6660c.png";